'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon$1 = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var fontIcon = require('../../icon/font-icon/font-icon.js');
var basePill = require('../base/base-pill.js');
var standardPill_module = require('./standard-pill.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Standard Pill variant provides an interactive pill.
 * The consumer can control the color and also allow the user to click on the pill as well as close it.
 *
 * @param props StandardPillProps
 * @returns FunctionComponent<StandardPillProps>
 */ const StandardPill = (props)=>{
    const { error , ...otherProps } = props;
    const backgroundColor = ()=>{
        if (error) return colors.BrandfolderHexColors.Delete;
        if (props.backgroundColor) return props.backgroundColor;
        return colors.BrandfolderHexColors.Marshmallow;
    };
    const borderColor = ()=>{
        if (error) return colors.BrandfolderHexColors.Delete;
        if (props.borderColor) return props.borderColor;
        if (props.backgroundColor) return props.backgroundColor;
        return colors.BrandfolderHexColors.Marshmallow;
    };
    const fontColor = ()=>{
        if (error) return colors.BrandfolderHexColors.White;
        if (props.fontColor) return props.fontColor;
        return undefined;
    };
    const baseProps = {
        ...otherProps,
        'aria-invalid': !!error,
        backgroundColor: backgroundColor(),
        borderColor: borderColor(),
        className: classnames__default.default(props.className, {
            [standardPill_module.invalid]: !!error
        }),
        fontColor: fontColor(),
        styleClasses: standardPill_module,
        variantName: 'standard'
    };
    return /*#__PURE__*/ React__default.default.createElement(basePill.BasePill, _extends({}, baseProps), error && /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, {
        icon: fontIcon$1.FontIcons.Warning
    }), baseProps.children);
};

exports.StandardPill = StandardPill;
//# sourceMappingURL=standard-pill.js.map
